import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

import Logo from '../../images/logo-2.svg'
import HeroContact from '../../images/contact/hero-contact.jpg'
import './ContactPage.css'

const ContactPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Contact Amped Therapeutics | Schedule Consultation in Sarasota, Fort Myers, Naples</title>
                <meta name="description" content="Schedule your regenerative medicine consultation with Dr. Eugene Pereira. Concierge service available throughout Florida including Sarasota, Fort Myers, Naples, Bradenton, Venice. Book your stem cell therapy consultation today." />
                <meta name="keywords" content="schedule stem cell consultation Florida, regenerative medicine appointment Sarasota, Fort Myers stem cell doctor, Naples regenerative medicine, concierge medical consultation, Dr. Pereira consultation" />
                <meta property="og:title" content="Contact Amped Therapeutics - Schedule Your Florida Consultation" />
                <meta property="og:description" content="Schedule your concierge regenerative medicine consultation. Dr. Eugene Pereira serves Sarasota, Fort Myers, Naples and throughout Florida." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/contact" />
                <link rel="canonical" href="https://ampedtherapeutics.com/contact" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            <div className="contact-hero-wrapper" style={{
                backgroundImage: `url(${HeroContact})`
            }}>
                <PageTitle pageTitle={'Schedule Your Florida Stem Cell Consultation'} pagesub={'Contact'} />
            </div>
            <Contactpage />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

